export const PRICE_TAG_COLOR = "#2A2A2ACC"

export const TEXT_COLOR_ON_DARK = "#FFFFFF"
export const TEXT_COLOR_ON_LIGHT = "#2A2A2A"